import type { MagentoShippingMethod } from "@jti/magento-types";

export const pickDeliveryOption = (
  preparedOptions: MagentoShippingMethod[],
  lastOrderShippingMethodCode: string | undefined
) => {
  if (!lastOrderShippingMethodCode) return undefined;

  /* 
    LastCustomerOrder returns shipping_method_code in format: "{carrier_code}_{method_code}"
    We need to match against available options by constructing the same format
  */
  const matchedDeliveryOption = preparedOptions.find((option) => {
    const combinedCode = `${option.carrierCode}_${option.methodCode}`;
    return combinedCode === lastOrderShippingMethodCode;
  });

  if (!matchedDeliveryOption?.methodCode) {
    return undefined;
  }

  return matchedDeliveryOption.methodCode;
};
